// extracted by mini-css-extract-plugin
export default {"load-game":"Loading_load-game__x78+b","rotation":"Loading_rotation__JI9XW"};